import cmp from 'common/navigation/layout/Layout'

export default cmp
